import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const SaveIcon = ({ label = 'Save', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M246.4 92.2a21.6 21.6 0 0 1 6.4 15.6v123a21.9 21.9 0 0 1-22 22H69.2a21.9 21.9 0 0 1-22-22V69.2a21.9 21.9 0 0 1 22-22h123a21.6 21.6 0 0 1 15.6 6.4z" style="fill:#ee8875"/><path d="M192.2 47.2a21.6 21.6 0 0 1 15.6 6.4l38.6 38.6a21.6 21.6 0 0 1 6.4 15.6v123a21.9 21.9 0 0 1-22 22H69.2a21.9 21.9 0 0 1-22-22V69.2a21.9 21.9 0 0 1 22-22h123m0-10h-123a32.1 32.1 0 0 0-32 32v161.6a32.1 32.1 0 0 0 32 32h161.6a32.1 32.1 0 0 0 32-32v-123a31.6 31.6 0 0 0-9.4-22.7l-38.5-38.5a31.6 31.6 0 0 0-22.7-9.4z" style="fill:#1d1d1b"/><path d="M150 208.4a28.1 28.1 0 0 0 20.5-8.6 28.9 28.9 0 0 0 0-40.9 29 29 0 0 0-49.5 20.5 27.8 27.8 0 0 0 8.5 20.4 28.1 28.1 0 0 0 20.5 8.6z" style="fill:#fff"/><path d="M150 150.3a29.2 29.2 0 0 1 29 29.1 27.8 27.8 0 0 1-8.5 20.4 28.7 28.7 0 0 1-41 0 28.9 28.9 0 0 1 0-40.9 28.1 28.1 0 0 1 20.5-8.6m0-10a39.3 39.3 0 0 0-39 39.1 39.3 39.3 0 0 0 39 39 39.3 39.3 0 0 0 39-39 39.3 39.3 0 0 0-39-39.1z" style="fill:#1d1d1b"/><path style="fill:#fff" d="M80.2 47.2H188v57.99H80.2z"/><path d="M188 47.2v58H80.2v-58H188m0-9.3H80.2a9.3 9.3 0 0 0-9.3 9.3v58a9.3 9.3 0 0 0 9.3 9.3H188a9.3 9.3 0 0 0 9.3-9.3v-58a9.3 9.3 0 0 0-9.3-9.3z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

SaveIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { SaveIcon }
